import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

type IProps = Immutable<{
    showVerboseUserInfo: boolean;
    user: string;
    location: string;
    formattedDate: string | null;
}>;

const buildLocation = (location: string): string => {
    if (location && location.toLowerCase() === "undisclosed") {
        return t`Location Undisclosed`;
    }
    return location;
};

export const ReviewUserInfo = ({
    showVerboseUserInfo,
    user,
    location,
    formattedDate,
}: IProps): React.ReactNode => {
    const processedLocation = buildLocation(location);

    if (showVerboseUserInfo) {
        return (
            <div className="customer-review__review-item__review-author">
                – by <strong>{`${user}`}</strong> from
                {processedLocation ? ` ${processedLocation}` : null}
                {` on ${formattedDate}`}
            </div>
        );
    } else {
        return (
            <div className="customer-review__review-item__review-author">
                {user}
                {processedLocation ? `, ${processedLocation}` : null}
            </div>
        );
    }
};
